import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ActionReducerMap, StoreModule } from "@ngrx/store";
import { MatCoreModule } from "@obg/mat.ui.core";
import { rehydrate } from "@obg/ngrx-utils";
import { CoreContentModule } from "@obg/ngx.core.content";

import { CustomerInteractionsEffects } from "./customer-interactions/customer-interactions.effect";
import { CustomerLimitNotificationsEffects } from "./customer-limit-notifications/customer-limit-notifications.effect";
import { RealTimeNotificationsEffect } from "./real-time-notifications/real-time-notifications.effect";
import { realTimeNotificationsReducer } from "./real-time-notifications/real-time-notifications.reducer";
import { NotificationResultEffect } from "./rg-interactions/notification-result/notification-result.effect";
import { RgInteractionsEffect } from "./rg-interactions/rg-interactions.effect";
import { rgInteractionsReducer } from "./rg-interactions/rg-interactions.reducer";
import { RealtimeNotificationsFeatureState } from "./state";

export const REALTIME_NOTIFICATIONS_FEATURE_REDUCER: ActionReducerMap<
	RealtimeNotificationsFeatureState["realtimeNotificationsFeature"]
> = {
	realtimeNotifications: realTimeNotificationsReducer,
	rgInteractions: rehydrate(rgInteractionsReducer),
};

@NgModule({
	imports: [
		CoreContentModule,
		MatCoreModule,
		CommonModule,
		EffectsModule.forFeature([
			RealTimeNotificationsEffect,
			RgInteractionsEffect,
			NotificationResultEffect,
			CustomerLimitNotificationsEffects,
			CustomerInteractionsEffects,
		]),
		StoreModule.forFeature("realtimeNotificationsFeature", REALTIME_NOTIFICATIONS_FEATURE_REDUCER),
	],
})
export class RealtimeNotificationsModule {
	static forRoot(): ModuleWithProviders<RealtimeNotificationsModule> {
		return {
			ngModule: RealtimeNotificationsModule,
		};
	}
}
